import {CdtrAcctIban} from '../models/cdtr-acct-iban-state.model';

export class SetCdtrAcctIban {
  static readonly type = '[Creditor Account IBAN] Set buttons settings';

  constructor(public payload: CdtrAcctIban) {
  }
}
